// extracted by mini-css-extract-plugin
export default {"proLContainer":"proLargeNavbar_proLContainer__V0EH3","proLDiv2":"proLargeNavbar_proLDiv2__oalRW"};